// eslint-disable-next-line no-unused-vars
export default theme => ({
  root: {},
  tableSettings: {
    position: 'absolute',
    left: 0,
    top: theme.spacing(-4),
  },
});
